import { AppStore } from '@storage/stores/app.store'
import { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { ShouldTriggerLoadingProvider } from '../exclude-from-loading'

export const onFulfilled = (appStore: AppStore) => {
  return (request: InternalAxiosRequestConfig<any>) => {
    if (ShouldTriggerLoadingProvider.get(request)) {
      appStore.showLoader()
    }

    return request
  }
}

export const onRejected = (appStore: AppStore) => {
  return (error: AxiosError) => {
    appStore.hideLoader()

    return Promise.reject(error)
  }
}
